import React from 'react';

const steps = [
  { n: '01', t: 'Install single tag', b: 'One JS snippet. No variables, no conditions, no engineering sprint.' },
  { n: '02', t: 'We configure events', b: 'Our team handles 100% of event setup and data layer configuration.' },
  { n: '03', t: 'AI modeling begins', b: 'Data collection starts. Intent models calibrate to your audience.' },
  { n: '04', t: 'Creative production', b: 'Dynamic ad creatives built by our team — included in your package.' },
  { n: '05', t: 'Convert & scale', b: 'Revenue events fire. You pay only on verified sales. We optimize daily.' },
];

export default function OnboardingSection() {
  return (
    <section className="highlights-section" id="onboarding" data-testid="onboarding-section">
      <div className="highlights-glow highlights-glow-one" />
      <div className="highlights-glow highlights-glow-two" />
      <div className="container-r360">
        <div className="highlights-kicker">
          <span />GETTING STARTED
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 xl:gap-10 md:gap-6 items-start">
          <h2 className="reveal-on-scroll lg:col-span-7 font-display text-[3.25rem] sm:text-[4.5rem] xl:text-[5.75rem] font-bold leading-[0.92] tracking-[-0.03em] text-[#262626]">
            Live In <span className="accent">48 Hours.</span><br />Guaranteed.
          </h2>
          <div className="lg:col-span-5">
            <p className='reveal-on-scroll sec-subhead leading-relaxed'>
              Launch in just 48 hours—guaranteed. From setup to activation, our team handles everything seamlessly so you can start recovering lost revenue fast, with zero complexity, zero delays, and no internal engineering required.
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-0 border-t border-l border-[#1a1a1a]">
          {steps.map((s) => (
            <div key={s.n} className="p-4 xl:p-7 border-r border-b border-[#1a1a1a] relative group transition-colors bg-white/70">
              <div className="text-[1.5rem] font-mono font-bold text-[#ff5117] mb-1 ">{s.n}</div>
              <div className="font-display text-[18px] md:text-[22px] font-bold mb-2 lg:mb-4 leading-[1.25]">{s.t}</div>
              <p className="sec-subhead leading-relaxed">{s.b}</p>
            </div>
          ))}
        </div>

        <div className="mt-6 lg:mt-10 flex flex-wrap gap-2 md:gap-5 lg:gap-8 justify-between font-bold">
          <span>▪ Zero-risk guarantee</span>
          <span>▪ No minimum budget</span>
          <span>▪ Creatives included</span>
          <span>▪ Fully managed team</span>
        </div>
      </div>
    </section>
  );
}
